var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.3333 13.3333V2.5H0.833328V13.3333H13.3333ZM13.3333 13.3333H19.1667V9.16667L16.6667 6.66667H13.3333V13.3333ZM6.66666 15.4167C6.66666 16.5673 5.73392 17.5 4.58333 17.5C3.43273 17.5 2.49999 16.5673 2.49999 15.4167C2.49999 14.2661 3.43273 13.3333 4.58333 13.3333C5.73392 13.3333 6.66666 14.2661 6.66666 15.4167ZM17.5 15.4167C17.5 16.5673 16.5673 17.5 15.4167 17.5C14.2661 17.5 13.3333 16.5673 13.3333 15.4167C13.3333 14.2661 14.2661 13.3333 15.4167 13.3333C16.5673 13.3333 17.5 14.2661 17.5 15.4167Z",
    stroke: "#7F818D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.9736f4f111225ba494594467ac9c1627.svg";
export { ForwardRef as ReactComponent };